import { Kind } from "@/services/backend/rlt/treatments/types/component";
import t from "@/lang/lang";
import { cn } from "@/shared/lib/utils";

export function KindCell({
  kind,
  className = "",
}: {
  kind: Kind;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex h-6 items-center font-bold whitespace-nowrap",
        className,
      )}
    >
      {t(kind)}
    </div>
  );
}
